<template>
  <main>
    <div class="header"><img src="../assets/logo.png" /></div>
    <section class="first-view">
      <div class="video-box">
        <video src="@/assets/kv_video.mp4" playsinline autoplay muted loop />
      </div>
      <img
        style="margin-top: -220px;"
        v-lazy="images.kv[0]"
        :data-srcset="`${images.kv[0]} 1x, ${images.kv[1]} 2x`"
        alt=""
      />
      <img
        class="youtuber"
        v-lazy="images.youtuber[0]"
        :data-srcset="`${images.youtuber[0]} 1x, ${images.youtuber[1]} 2x`"
        alt=""
      />
    </section>
    <a
      href="https://royalhoney.company/products/royal-honey-vip-1/"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        v-lazy="images.repeatno1[0]"
        :data-srcset="`${images.repeatno1[0]} 1x, ${images.repeatno1[1]} 2x`"
        alt=""
      />
    </a>
    <img
      v-lazy="images.kindanrh[0]"
      :data-srcset="`${images.kindanrh[0]} 1x, ${images.kindanrh[1]} 2x`"
      alt=""
    />
    <img
      v-lazy="images.kaiketsu[0]"
      :data-srcset="`${images.kaiketsu[0]} 1x, ${images.kaiketsu[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 2; margin-bottom: -60px;"
      v-lazy="images.nayami[0]"
      :data-srcset="`${images.nayami[0]} 1x, ${images.nayami[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 2; margin-bottom: -120px;"
      v-lazy="images.hannou[0]"
      :data-srcset="`${images.hannou[0]} 1x, ${images.hannou[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 1; margin-bottom: -250px;"
      v-lazy="images.hannou2[0]"
      :data-srcset="`${images.hannou2[0]} 1x, ${images.hannou2[1]} 2x`"
      alt=""
    />
    <div class="repeaters">
      <img
        v-lazy="images.repeater[0]"
        :data-srcset="`${images.repeater[0]} 1x, ${images.repeater[1]} 2x`"
        alt=""
      />
      <div class="faces" ref="faces">
        <img
          v-lazy="images.customerfaces1[0]"
          :data-srcset="
            `${images.customerfaces1[0]} 1x, ${images.customerfaces1[1]} 2x`
          "
          alt=""
        />
        <img
          v-lazy="images.customerfaces2[0]"
          :data-srcset="
            `${images.customerfaces2[0]} 1x, ${images.customerfaces2[1]} 2x`
          "
          alt=""
        />
        <img
          v-lazy="images.customerfaces1[0]"
          :data-srcset="
            `${images.customerfaces1[0]} 1x, ${images.customerfaces1[1]} 2x`
          "
          alt=""
        />
      </div>
    </div>
    <img
      style="margin-top: 40px;"
      v-lazy="images.reaction[0]"
      :data-srcset="`${images.reaction[0]} 1x, ${images.reaction[1]} 2x`"
      alt=""
    />
    <img
      style="margin-top: 40px;"
      v-lazy="images.totalSales[0]"
      :data-srcset="`${images.totalSales[0]} 1x, ${images.totalSales[1]} 2x`"
      alt=""
    />
    <img
      style="margin-top: 24px; padding: 0 24px;"
      v-lazy="images.orderhead[0]"
      :data-srcset="`${images.orderhead[0]} 1x, ${images.orderhead[1]} 2x`"
      alt=""
    />
    <div class="latest-orders">
      <div class="times">
        <p>（最新注文状況 100 件）</p>
        <p>{{ currentDate }}</p>
      </div>
      <div class="orders-wrapper">
        <div class="orders" ref="orders">
          <img
            v-for="n in currentOrders"
            :key="n"
            v-lazy="orderImage(n)[0]"
            :data-srcset="`${orderImage(n)[0]} 1x, ${orderImage(n)[1]} 2x`"
            alt=""
          />
        </div>
      </div>
    </div>
    <img
      style="margin-bottom: -8px;"
      v-lazy="images.snswadai[0]"
      :data-srcset="`${images.snswadai[0]} 1x, ${images.snswadai[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 1; margin-bottom: -64px;"
      v-lazy="images.reason[0]"
      :data-srcset="`${images.reason[0]} 1x, ${images.reason[1]} 2x`"
      alt=""
    />
    <img
      style="margin-bottom: 32px;"
      v-lazy="images.healthy[0]"
      :data-srcset="`${images.healthy[0]} 1x, ${images.healthy[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 2; margin-bottom: -16px;"
      v-lazy="images.materials[0]"
      :data-srcset="`${images.materials[0]} 1x, ${images.materials[1]} 2x`"
      alt=""
    />
    <img
      style="position: relative; z-index: 1; margin-bottom: -120px;"
      v-lazy="images.benefits[0]"
      :data-srcset="`${images.benefits[0]} 1x, ${images.benefits[1]} 2x`"
      alt=""
    />
    <img
      style="margin-bottom: 56px;"
      v-lazy="images.kodawari[0]"
      :data-srcset="`${images.kodawari[0]} 1x, ${images.kodawari[1]} 2x`"
      alt=""
    />
    <img
      style="margin-bottom: 40px;"
      v-lazy="images.getthelife[0]"
      :data-srcset="`${images.getthelife[0]} 1x, ${images.getthelife[1]} 2x`"
      alt=""
    />
    <a
      href="https://royalhoney.company/products"
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        v-lazy="images.setprice[0]"
        :data-srcset="`${images.setprice[0]} 1x, ${images.setprice[1]} 2x`"
        alt=""
      />
    </a>
    <img
      style="margin-top: 80px;"
      v-lazy="images.couple[0]"
      :data-srcset="`${images.couple[0]} 1x, ${images.couple[1]} 2x`"
      alt=""
    />
    <div class="cvp-1">
      <a
        href="https://royalhoney.company/products/royal-honey-vip-1/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          v-lazy="images.cvp1[0]"
          :data-srcset="`${images.cvp1[0]} 1x, ${images.cvp1[1]} 2x`"
          alt=""
        />
      </a>
      <a
        class="official-site"
        href="https://royalhoney.company/products"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          style="margin-top: -8px;"
          v-lazy="images.officialsite[0]"
          :data-srcset="
            `${images.officialsite[0]} 1x, ${images.officialsite[1]} 2x`
          "
          alt=""
        />
      </a>
    </div>
    <img
      style="position: relative; z-index: 1; margin-bottom: -88px;"
      v-lazy="images.fivept[0]"
      :data-srcset="`${images.fivept[0]} 1x, ${images.fivept[1]} 2x`"
      alt=""
    />
    <img
      style="margin-bottom:48px"
      v-lazy="images.assessment[0]"
      :data-srcset="`${images.assessment[0]} 1x, ${images.assessment[1]} 2x`"
      alt=""
    />
    <img
      v-lazy="images.description[0]"
      :data-srcset="`${images.description[0]} 1x, ${images.description[1]} 2x`"
      alt=""
    />
    <div class="cvp-2">
      <a
        href="https://royalhoney.company/products/royal-honey-vip-1/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          v-lazy="images.cvp1[0]"
          :data-srcset="`${images.cvp1[0]} 1x, ${images.cvp1[1]} 2x`"
          alt=""
        />
      </a>
      <a
        class="official-site"
        href="https://royalhoney.company/products"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          style="margin-top: -8px;"
          v-lazy="images.officialsite[0]"
          :data-srcset="
            `${images.officialsite[0]} 1x, ${images.officialsite[1]} 2x`
          "
          alt=""
        />
      </a>
    </div>
    <img
      style="margin-bottom: 8px;"
      v-lazy="images.footer[0]"
      :data-srcset="`${images.footer[0]} 1x, ${images.footer[1]} 2x`"
      alt=""
    />
  </main>
</template>

<script>
import gsap from "gsap";

export default {
  name: "Home",
  data() {
    return {
      currentOrder: 1,
      images: {
        kv: [
          require("../assets/images/KV.png"),
          require("../assets/images/KV@2x.png"),
        ],
        youtuber: [
          require("../assets/images/Youtuber.png"),
          require("../assets/images/Youtuber@2x.png"),
        ],
        repeatno1: [
          require("../assets/images/repeatNo1.png"),
          require("../assets/images/repeatNo1@2x.png"),
        ],
        kindanrh: [
          require("../assets/images/kindanRH.png"),
          require("../assets/images/kindanRH@2x.png"),
        ],
        kaiketsu: [
          require("../assets/images/kaiketsu.png"),
          require("../assets/images/kaiketsu@2x.png"),
        ],
        nayami: [
          require("../assets/images/nayami.png"),
          require("../assets/images/nayami@2x.png"),
        ],
        hannou: [
          require("../assets/images/hannou.png"),
          require("../assets/images/hannou@2x.png"),
        ],
        hannou2: [
          require("../assets/images/hannou2.png"),
          require("../assets/images/hannou2@2x.png"),
        ],
        repeater: [
          require("../assets/images/repeater.png"),
          require("../assets/images/repeater@2x.png"),
        ],
        customerfaces1: [
          require("../assets/images/customerfaces1.png"),
          require("../assets/images/customerfaces1@2x.png"),
        ],
        customerfaces2: [
          require("../assets/images/customerfaces2.png"),
          require("../assets/images/customerfaces2@2x.png"),
        ],
        reaction: [
          require("../assets/images/reaction.png"),
          require("../assets/images/reaction@2x.png"),
        ],
        totalSales: [
          require("../assets/images/totalSales.png"),
          require("../assets/images/totalSales@2x.png"),
        ],
        orderhead: [
          require("../assets/images/orderhead.png"),
          require("../assets/images/orderhead@2x.png"),
        ],
        snswadai: [
          require("../assets/images/snswadai.png"),
          require("../assets/images/snswadai@2x.png"),
        ],
        reason: [
          require("../assets/images/reason.png"),
          require("../assets/images/reason@2x.png"),
        ],
        healthy: [
          require("../assets/images/healthy.png"),
          require("../assets/images/healthy@2x.png"),
        ],
        materials: [
          require("../assets/images/materials.png"),
          require("../assets/images/materials@2x.png"),
        ],
        benefits: [
          require("../assets/images/benefits.png"),
          require("../assets/images/benefits@2x.png"),
        ],
        kodawari: [
          require("../assets/images/kodawari.png"),
          require("../assets/images/kodawari@2x.png"),
        ],
        getthelife: [
          require("../assets/images/getthelife.png"),
          require("../assets/images/getthelife@2x.png"),
        ],
        setprice: [
          require("../assets/images/setprice.png"),
          require("../assets/images/setprice@2x.png"),
        ],
        couple: [
          require("../assets/images/couple.png"),
          require("../assets/images/couple@2x.png"),
        ],
        cvp1: [
          require("../assets/images/cvp1.png"),
          require("../assets/images/cvp1@2x.png"),
        ],
        officialsite: [
          require("../assets/images/officialsite.png"),
          require("../assets/images/officialsite@2x.png"),
        ],
        fivept: [
          require("../assets/images/fivept.png"),
          require("../assets/images/fivept@2x.png"),
        ],
        assessment: [
          require("../assets/images/assessment.png"),
          require("../assets/images/assessment@2x.png"),
        ],
        description: [
          require("../assets/images/description.png"),
          require("../assets/images/description@2x.png"),
        ],
        footer: [
          require("../assets/images/footer.png"),
          require("../assets/images/footer@2x.png"),
        ],
      },
    };
  },

  computed: {
    currentDate() {
      const now = new Date();
      const month = now.getMonth() + 1;
      const day = now.getDate();
      const hour = now.getHours();
      const min = now.getMinutes();
      const dayofweek = now.getDay();
      const youbi = new Array("日", "月", "火", "水", "木", "金", "土");
      return `${month}月${day}日（${youbi[dayofweek]}曜日）: ${hour}時${min}分更新`;
    },
    currentOrders() {
      const orders = [];
      for (let i = 0; i < 7; i++) {
        if (this.currentOrder + i > 20) {
          orders.push(-(20 - this.currentOrder - i));
        } else {
          orders.push(this.currentOrder + i);
        }
      }
      return orders;
    },
    orderImage() {
      return (n) => {
        return [
          require(`../assets/images/orders/${n}.png`),
          require(`../assets/images/orders/${n}@2x.png`),
        ];
      };
    },
  },

  watch: {
    currentOrder: function(newVal) {
      const orders = this.$refs.orders.children;
      const randomDelayTime = gsap.utils.random(0, 3);
      gsap.fromTo(
        orders,
        {
          y: -95,
        },
        {
          duration: 0.8,
          delay: randomDelayTime,
          y: 0,
          onComplete: () => {
            if (newVal > 20) {
              this.currentOrder = 2;
              return;
            }
            this.currentOrder++;
          },
        }
      );
    },
  },

  mounted() {
    const faces = this.$refs.faces;
    const tl1 = gsap.timeline();
    const scrollFaces = tl1.to(faces, { x: -828, duration: 16, ease: "none" });
    scrollFaces.repeat(-1);

    const orders = this.$refs.orders.children;
    gsap.defaults({ ease: "back.out(1)" });
    gsap.fromTo(
      orders,
      {
        y: -95,
      },
      {
        duration: 0.8,
        y: 0,
        onComplete: () => {
          this.currentOrder++;
        },
      }
    );
  },
};
</script>

<style lang="scss" scoped>
a {
  display: flex;
  align-items: flex-start;
  margin-bottom: -1px;
}

img {
  width: calc(100% + 0.5px);
}
.header {
  margin: 15px 0px;
  position: relative;
  text-align: center;
  z-index: 1000;
  img {
    width: 150px;
  }
}
.first-view {
  position: relative;
  margin-bottom: 48px;

  > .video-box {
    width: 100%;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    &::before {
      content: "";
      display: block;
      position: absolute;
      bottom: 0;
      background: linear-gradient(rgba(0, 0, 0, 0), #000);
      width: 100%;
      height: 64px;
    }
    > video {
      width: 100%;
    }
  }

  > .youtuber {
    position: absolute;
    bottom: -48px;
    left: 0;
    padding: 0 16px;
  }
}

.repeaters {
  position: relative;

  > .faces {
    display: flex;
    align-items: flex-start;
    position: absolute;
    bottom: 240px;
    width: 100%;
    > img {
      min-width: 100%;
    }
  }
}

.latest-orders {
  margin-bottom: 40px;

  > .times {
    text-align: center;
    font-size: 14px;
    margin-bottom: 12px;
  }

  > .orders-wrapper {
    height: 475px;
    padding: 0 16px;
    overflow: hidden;
    > .orders {
      display: flex;
      flex-direction: column-reverse;
      justify-content: flex-end;
      transform: translateY(-95px);
      > img {
        width: 100%;
        height: 90px;
        margin-bottom: 5px;
      }
    }
  }
}

.cvp-1 {
  position: relative;
  margin-top: -8px;
  margin-bottom: -56px;
  z-index: 2;

  > .official-site {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 16px;
  }
}

.cvp-2 {
  position: relative;
  margin-top: -8px;
  z-index: 2;

  > .official-site {
    position: absolute;
    bottom: 40px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    padding: 0 16px;
  }
}
</style>
